export default () => {
    const elements = document.querySelectorAll('[data-visibility-handler]');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const element = entry.target;
                if (entry.isIntersecting) {
                    element.classList.add('is-visible');
                } else if (element.dataset.visibilityHandler === 'toggle') {
                    element.classList.remove('is-visible');
                }
            });
        },
        {
            rootMargin: '0px 0px',
        }
    );

    elements.forEach((element) => {
        observer.observe(element);
    });
};
